import React, { useEffect } from 'react';
import useLadyService from '@/services/LadyService';
import {
	getScrolledClass,
	setScrolledClass,
} from '@/stores/slices/headerSlice';
import { useSelector } from 'react-redux';
import {
	Default,
	ModelOrAgency,
	UserOrPhotograph,
	ModerOrAdmin,
	ModerOrAdminLK,
} from './variants';
import './header.scss';

const Header = ({ isLk }) => {
	const { dispatch, windowWidth, userType } = useLadyService();

	const scrolledClass = useSelector(getScrolledClass);

	useEffect(() => {
		if (windowWidth > 767.98) {
			window.addEventListener('scroll', () => {
				if (window.scrollY < 1) {
					dispatch(setScrolledClass(''));
				} else {
					dispatch(setScrolledClass(' _scroll'));
				}
			});
		}
	}, [windowWidth, window]);

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	return (
		<header
			className={`${headerClassByUserType()}${
				scrolledClass && windowWidth > 767.98 ? ` ${scrolledClass}` : ''
			} ${isJsdom ? 'ssr' : ''}`}
		>
			<div
				className={
					isJsdom ? 'header__container ssr' : 'header__container'
				}
			>
				{headerContentByUserType()}
			</div>
		</header>
	);

	function headerClassByUserType() {
		switch (userType) {
			case 'photograph':
			case 'customer': {
				return 'header--type-one';
			}
			case 'agency':
			case 'indi': {
				return 'header--type-two';
			}
			default: {
				return '';
			}
		}
	}

	function headerContentByUserType() {
		switch (userType) {
			case 'photograph':
			case 'customer': {
				return <UserOrPhotograph />;
			}

			case 'indi':
			case 'agency': {
				return <ModelOrAgency isLk={isLk} />;
			}

			case 'admin':
			case 'moderator': {
				return isLk ? <ModerOrAdminLK /> : <ModerOrAdmin />;
			}

			default: {
				return <Default />;
			}
		}
	}
};
export default Header;
